<template>
	<div class="msg_box">
		<div class="forget_box">
			<div v-if="isNext">
				<p class="for_title">忘记密码</p>
				<p>请输入与您的账号关联的电子邮件地址或手机号，然后“提交”，注意查收验证码</p>
				<el-form label-position="left" label-width="180px" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
					<el-form-item label="电子邮箱/手机" prop="phone">
						<el-input v-model="ruleForm.phone">
							<template slot="append">
								<div v-if="isyzm"  @click="setyzm" class="laing_btn">获取验证码</div>
								<div v-else class="reg_number">{{yzmnumber}}秒后重试</div>
							</template>
						</el-input>
					</el-form-item>
					<el-form-item label="验证码" prop="yzm">
						<el-input v-model="ruleForm.yzm">

						</el-input>
					</el-form-item>
				</el-form>
				<div class="next laing_btn" @click="next">下一步</div>
			</div>
			<div v-else>
				<p class="for_title">重设密码</p>
				<el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm2">
					<el-form-item label="请输入新密码" prop="password">
						<el-input v-model="ruleForm.password" show-password> </el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="repassword">
						<el-input v-model="ruleForm.repassword" show-password></el-input>
					</el-form-item>
				</el-form>
				<button class="next laing_btn" v-preventReClick @click="setUserPwd">确定</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			 var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.repassword !== '') {
						this.$refs.ruleForm2.validateField('repassword');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				isyzm:true,
				yzmnumber:60,
				isNext:true,
				phoneYzm:'',
				timeYzm:-1,
				ruleForm: {
					phone: '',
					yzm: '',
					password:'',
					repassword:''
				},
				rules: {
					phone: [{ required: true, message: '电子邮箱/手机', trigger: 'blur' } ],
					yzm: [{ required: true, message: '请输入验证码', trigger: 'blur' } ],
					password:{ validator: validatePass, trigger: 'blur' },
					repassword: { validator: validatePass2, trigger: 'blur' }
				}
			}
		},
		methods: {
			setUserPwd(){//修改密码
			 this.$refs.ruleForm2.validate(async (valid) => {
					if(!valid)return;
					let ruleForm = this.ruleForm;
					ruleForm.code = ruleForm.yzm;
					ruleForm.name = ruleForm.phone;
					let {code,data} = await this.api.PostUserSetPwd(ruleForm);
					if(code==200){
						this.$message({ message: '恭喜你，密码修改成功!', type: 'success' });
						this.xin.goUrl('/login');
					}
				  });
			},
			next(){//下一步
				  this.$refs.ruleForm.validate(async (valid) => {
					if(!valid)return;
					let {code} = await this.api.PostforgetpasCode({
						name:this.ruleForm.phone,
						code:this.ruleForm.yzm
					});
					if(code==200)
						this.isNext = false;
				  });
			},
			async setyzm(){//获取手机验证码
			if (!this.ruleForm.phone) {
				this.$message({ message: "请输入手机号/邮箱", type: "warning" });
				return;
			}
				this.isyzm = false;
				this.yzmnumber = 60;
				let {code} = await this.api.PostforgetPwd({name:this.ruleForm.phone});
				// this.phoneYzm = data;

				//倒计时
				this.timeYzm = setInterval(()=>{
					this.yzmnumber--;
					if(this.yzmnumber<0){
						this.isyzm = true;
						clearTimeout(this.timeYzm);
					}
				},1000);
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.forget_box {
		margin-top: 50px;
		width: 550px;
		color: #444;

		.next {
			width: 200px;
			height: 40px;
			line-height: 40px;
		}

		.for_title {
			font-size: 20px;
		}

		.laing_btn {
			line-height: 40px;
			width: 100px;
		}

		/deep/ .el-input-group__append,
		.el-input-group__prepend {
			padding: 0;
		}
	}
</style>
